// client/src/inquiries/index.ts
import { InquiryList } from './InquiryList';
import { InquiryEdit } from './InquiryEdit';
import { InquiryCreate } from './InquiryCreate';
import InquiryIcon from '@mui/icons-material/QuestionAnswer';

export default {
    list: InquiryList,
    edit: InquiryEdit,
    create: InquiryCreate,
    icon: InquiryIcon,
};

